import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'clsx';

import { ConsentsSectionProps } from './ConsentsSection.interfaces';
import { FormRow } from 'app/components/FormRow';
import { RootState } from 'app/store/rootReducer';
import { getVisibleQuestionsCount } from 'app/store/data/formsConfig';
import { useStyles } from './ConsentsSection.styles';
import { FormsEnum } from 'app/shared/enums/Forms.enum';
import { FormTooltip } from '../FormTooltip';
import { selectIsCepik3PathActive } from 'app/store/selectors/selectIsCepik3PathActive';

export default function ConsentsSection({
  questionKeys,
  formName,
  tooltip,
}: ConsentsSectionProps) {
  const classes = useStyles();
  const visibleQuestionsCount = useSelector((state: RootState) =>
    getVisibleQuestionsCount({
      state,
      formName,
      questionKeys,
    })
  );
  const isCepik3ShortPath = useSelector(selectIsCepik3PathActive);

  if (questionKeys.length === 0 || visibleQuestionsCount === 0) {
    return null;
  }

  return visibleQuestionsCount > 1 ||
    (formName === FormsEnum.CalculationFirstStepForm && !isCepik3ShortPath) ? (
    <div
      className={classNames(classes.root, {
        [classes.consentsFirstStepRoot]:
          formName === FormsEnum.CalculationFirstStepForm && !isCepik3ShortPath,
      })}
      id="consent-wrapper"
    >
      <div
        className={classNames(classes.consents, {
          [classes.consentsFirstStepWrapper]:
            formName === FormsEnum.CalculationFirstStepForm &&
            !isCepik3ShortPath,
        })}
      >
        {questionKeys.map((questionKey) => (
          <FormRow
            className={classNames(
              classes.formRow,
              classes.formRowMultipleConsents
            )}
            key={questionKey}
            questionKey={questionKey}
            formName={formName}
          />
        ))}
      </div>
      <FormTooltip content={tooltip} className={classes.tooltip} />
    </div>
  ) : (
    <>
      {questionKeys.map((questionKey) => (
        <FormRow
          className={classes.formRow}
          key={questionKey}
          questionKey={questionKey}
          formName={formName}
        />
      ))}
    </>
  );
}
